import queryString from "query-string";
import { warn } from "rtUtils/logger";
import { decodeObjectString } from "./objectEncoderDecoder";

const qs = queryString.parse(location.search);

const getProductConfigFromQuery = ( ) => {
	const productConfigQuery = qs.productConfig;
	let configs = [];
	if (productConfigQuery?.length) {
		try {
			configs = productConfigQuery.split(",")
				.map((str) => {
					const decoded = decodeObjectString(str);
					return JSON.parse(decoded);
				});
		} catch (ex) {
			warn("failed to parse product-configs from query", productConfigQuery);
		}
	}

	return configs;
};

export default getProductConfigFromQuery;
